import React from 'react'

import {ColorBarContainerBottom, LegendBottomText } from './styled-elements'

export default class WindSpeedLegendTip extends React.Component {

  renderBody = ({ tip }) =>
    <ColorBarContainerBottom>
    <LegendBottomText>{tip}</LegendBottomText>
  </ColorBarContainerBottom>

  render() {
    return this.renderBody(this.props)
  }
}
